import { Component, h, Host, Prop, State } from "@stencil/core";
import {
  getIconName,
  markNotification,
  setLocalTime,
} from "@stores/notifications.store";

@Component({
  tag: "f-notification-flyout-content-section",
  styleUrl: "f-notification-flyout-content-section.scss",
  shadow: true,
})
export class NotificationFlyoutContentSection {
  @Prop() notifications;
  @Prop() delete;
  @Prop() removeNotificationLabel;
  @Prop() timeFormat;
  @Prop() numberOfShownNotifications = 3;
  @Prop() expanderButtonHiddenLabel: string;
  @Prop() unreadLabel;
  @Prop() readLabel;

  @State() max = this.numberOfShownNotifications;

  private loadMore = () => {
    this.max = this.max + this.numberOfShownNotifications;
  };

  render() {
    return (
      <Host>
        {this.notifications
          .slice(0, this.max)
          .map(
            ({
              read,
              code,
              creationTime,
              message,
              furtherInformation,
              type,
            }) => (
              <div class="notifications-flyout__list-item" key={code}>
                <div class="notifications-flyout__list-item__heading">
                  <p class="time">
                    {setLocalTime(creationTime, this.timeFormat)}
                  </p>
                  <div class="notifications-flyout__list-item__heading__action-buttons-group">
                    <f-button
                      variant="integrated"
                      icon-only="true"
                      onClick={() => {
                        markNotification([code], read ? "unread" : "read");
                      }}
                      additionalProps={{
                        title: read ? this.unreadLabel : this.readLabel,
                      }}
                    >
                      <f-visually-hidden>
                        {read ? this.unreadLabel : this.readLabel}
                      </f-visually-hidden>
                      <f-icon iconName={read ? "mail-open" : "mail"}></f-icon>
                    </f-button>
                    <f-button
                      variant="integrated"
                      icon-only="true"
                      onClick={() => {
                        this.delete(code);
                      }}
                      buttonTitle={this.removeNotificationLabel}
                    >
                      <f-visually-hidden>
                        {this.removeNotificationLabel}
                      </f-visually-hidden>
                      <f-icon iconName="delete"></f-icon>
                    </f-button>
                  </div>
                </div>
                <div class="notifications-flyout__list-item__main">
                  <f-icon iconName={getIconName(type)} />
                  <div class={read ? "read" : "unread"}>{message}</div>
                </div>
                <div
                  class="notifications-flyout__list-item__details"
                  innerHTML={furtherInformation}
                />
              </div>
            )
          )}
        {this.notifications.length > this.max && (
          <div
            class="notifications-flyout__load-more"
            data-test="notifications-flyout-load-more"
          >
            <f-button
              type="button"
              variant="transparent"
              iconOnly={true}
              additionalProps={{
                ariaLabel: "Load more",
              }}
              onClick={this.loadMore}
              data-test="notification-flyout-load-more-button"
            >
              <f-visually-hidden>
                {this.expanderButtonHiddenLabel}
              </f-visually-hidden>

              <f-icon iconName="options" size="2xl" />
            </f-button>
          </div>
        )}
      </Host>
    );
  }
}
